<template lang="html">
  <div class="ui search selection dropdown">
    <input type="hidden" name="city" />
    <i class="dropdown icon"></i>
    <div class="default text">Cidade</div>
    <div class="menu"></div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
export default {
  data() {
    return {};
  },

  mounted() {
    setTimeout(() => {
      this._initDropDown();
    }, 500);
  },

  methods: {
    _initDropDown() {
      let vm = this;
      let url = `${Api.baseURL}/cities?q[name_start]={query}`;
      $(this.$el).dropdown({
        saveRemoteData: false,
        minCharacters: 3,
        clearable: true,
        apiSettings: {
          url: url,
          dataType: 'json',
          method: 'get',
          cache: false,
          beforeXHR: xhr => {
            xhr.setRequestHeader(
              'Access-token',
              vm.$store.state.user.user.token
            );
            return xhr;
          }
        },

        fields: {
          remoteValues: 'cities',
          name: 'city_formatted',
          value: 'ibge_code'
        },

        onChange: function (value, text, $choice) {
          // vm.city_id = value;

          if (value == '') {
            vm.$emit('selected', { value: null, city_formatted: null });
          }

          if ($choice != undefined) {
            vm.$emit('selected', $choice.data());
          }
        }
      });

      // fix autocomplete
      $(this.$el).find('input.search').prop('autocomplete', 'nope');
    },

    setCity(city, ibge_code) {
      $(this.$el).dropdown('set text', city);
      $(this.$el).dropdown('set value', ibge_code);
    }
  }
};
</script>

<style lang="css" scoped></style>
